import React from 'react';
import Carousel from './Carousel';
import AboutSection from '../pages/AboutSection';
import Vehicles from '../pages/Vehicles';
import WhyChooseUs from '../pages/WhyChooseRentQ';
import PopularRentalLocations from '../pages/PopularRentalLocations';
import Testimonials from '../pages/Testimonials';
import FAQ from '../pages/FAQ';
import CTASection from '../pages/CTASection';
import VideoSlider from './VideoSlider';






const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
{/* <Carousel/> */}
<VideoSlider/>
<AboutSection/>
<Vehicles/>
<WhyChooseUs/>
<PopularRentalLocations/>
<Testimonials/>
<FAQ/>
<CTASection/>

    </div>
  );
};

export default HeroSection;
